import {h, Component} from 'preact'
import {FontPageActions, FontPageStore} from '../actions/actions'

export default class FontMenu extends Component {
  state = {
    fullFontList: FontPageStore.getFullFontList(),
    filteredFontList: FontPageStore.getFilteredFontList(),
    activeFilter: FontPageStore.getListFilter()
  }

  componentDidMount () {
    // wire up the store signals
    FontPageStore.fullFontListChanged.add(this.handleFullFontListChanged, this)
    FontPageStore.filteredFontListChanged.add(this.handleFilteredFontListChanged, this)
    FontPageStore.listFilterChanged.add(this.handleFilterChanged, this)
  }

  componentWillUnmount () {
    // destroy!
    FontPageStore.fullFontListChanged.remove(this.handleFullFontListChanged)
    FontPageStore.filteredFontListChanged.remove(this.handleFilteredFontListChanged)
    FontPageStore.listFilterChanged.remove(this.handleFilterChanged)
  }

  handleFullFontListChanged = (fullFontList) => {
    // grab the array of models out of backbone collection
    this.setState({
      fullFontList: fullFontList,
    })
  }

  handleFilteredFontListChanged = (filteredFontList) => {
    this.setState({
      filteredFontList: filteredFontList,
    })
  }

  handleFilterChanged = (activeFilter) => {
    this.setState({ activeFilter })
  }

  render () {
    let filteredList = this.state.filteredFontList
    let fullList = this.state.fullFontList
    // if the filtered list is 'all', we show no checkboxes
    var fontMenuItems = fullList.map(model => {
      const isChecked = 'all' !== this.state.activeFilter
        && filteredList.find(filteredModel => {
          return model.attributes.id === filteredModel.attributes.id
        })
      return <FontMenuItem model={model}
        onChecked={this.handleChecked} onUnchecked={this.handleUnchecked}
        checked={isChecked} key={'fm-' + model.attributes.id} />
    })

    return (
      <div className="columns">{fontMenuItems}</div>
    )
  }

  handleChecked = (menuItem) => {
    // If activeFilter is "all" then we'll only have one checkbox after this.
    if ("all" == this.state.activeFilter) {
      FontPageActions.setFilteredModels([menuItem.model])
    } else {
      FontPageActions.addModelToPage(menuItem.model)
    }
  }

  handleUnchecked = (menuItem) => {
    FontPageActions.removeModelFromPage(menuItem.model)
  }
}

export class FontMenuItem extends Component
{
  constructor (props) {
    super(props)
    this.model = props.model
    // set the initial state from props
    this.state = {
      _item: _.clone(this.model.attributes),
      checked: this.props.checked
    }
  }

  componentDidMount() {
    // wire up the backbone change events
    this.model.on('change', function (model) {
      this.setState({ _item: _.clone(model.attributes) })
    })
  }

  componentWillUnmount() {
    this.model.off('change')
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.checked !== this.props.checked){
      this.setState({checked: nextProps.checked})
    }
  }

  handleCheckboxToggle = (event) => {
    this.setState({
      checked: event.target.checked
    })
    if (event.target.checked) {
      this.props.onChecked(this)
    }
    else {
      this.props.onUnchecked(this)
    }
  }

  handleLinkClick = (event) => {
    event.preventDefault()
    const {_checkbox} = this
    _checkbox.checked = !_checkbox.checked
    // annoying...
    if ("createEvent" in document) {
      var evt = document.createEvent('HTMLEvents')
      evt.initEvent('change', false, true)
      _checkbox.dispatchEvent(evt)
    } else if (_checkbox.fireEvent) {
      _checkbox.fireEvent('onchange')
    }
  }

  handleCheckboxRef = (target) => {
    this._checkbox = target
  }

  render() {
    const atts = this.state._item;
    const imageSrc = atts.acf.menu_image_url
    ? `url("${atts.acf.menu_image_url}")`
    : `url("/fontgen?pid=${atts.acf.default_display_download}&t=${atts.title.rendered}&ps=20&fc=000000&bco=0&wi=276&hi=32&pt=7&pl=41")`
    return <div id={'family-' + atts.id} className="font-item">
      <label><input ref={this.handleCheckboxRef} checked={this.state.checked} type="checkbox" onChange={this.handleCheckboxToggle} />
        <span className="check"></span></label>
      <a style={{
        backgroundImage: imageSrc
      }} href={atts.link} onClick={this.handleLinkClick}>{atts.title.rendered}</a>
    </div>
  }
}



// WEBPACK FOOTER //
// ./inc/js/components/FontMenu.js